import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TicketDrawer from "./TicketDrawer";
import { Window, WindowMoveEvent } from "@progress/kendo-react-dialogs";
import { PartialSpinny } from "../Nav/Spinny";
import { TicketApi as Api } from "../../redux/api/TicketApi";
import { Button } from "@progress/kendo-react-buttons";
import { TicketLocationState } from "./TicketRoute";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { SetDescription } from "../../slices/TicketSlice";
import { SetHTML_Notes } from "../../slices/ActionSlice";

export const TicketPage = (props) => {
  const { logOptions } = useReduxSelector((state) => state.newTicket);
  const { Id: ticketId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useReduxDispatch();
  let background =
    location.state && (location.state as TicketLocationState).background;
  const [previousPage] = React.useState<Location>(background);
  let goBack = () => {
    if (previousPage) navigate(previousPage);
    else navigate("/");
    const blank = "";
    dispatch(SetDescription(blank));
    dispatch(SetHTML_Notes(blank));
  };

  const [expanded, setExpanded] = React.useState<boolean>(true);
  const [size, setSize] = React.useState<windowDims>({
    w: Math.max(window.innerWidth - 200, 500),
    h: window.innerHeight - 200,
  });

  const handleClick = (e) => {
    //console.log('handleClick',e)

    setExpanded(!expanded);
  };

  const resizing = (e: WindowMoveEvent) => {
    //console.log('resizing', e.width)
    setSize({ t: e.top, l: e.left, w: e.width, h: e.height });
    setExpanded(e.width < 660 ? false : true);
  };

  const moving = (e: WindowMoveEvent) => {
    if (e.top !== size.t || e.left !== size.l) {
      //console.log('moving')
      setSize({ ...size, t: e.top, l: e.left });
    }
  };

  window.onresize = (e: UIEvent) => {
    console.log("window resizing");
    let popupWidth = window.innerWidth - 200;
    setSize({ w: popupWidth, h: window.innerHeight - 200, t: 100, l: 100 });

    setExpanded(popupWidth < 660 ? false : true);
  };

  useEffect(() => {
    console.log("useEffect", size);
    //collapse the drawer when the popup gets smaller than 660px
    setExpanded(size.w < 660 ? false : true);
  }, [size]);

  //Raised when a ticket is saved. decides where we go from here
  const ticketSaved = (tIds: number[]) => {
    //Check log options
    let myOptions = logOptions?.Options?.split(",");
    //console.log('myOptions', myOptions)
    if (!myOptions) {
      goBack();
    }

    if (myOptions?.indexOf("0") > -1) {
      //Go to the ticket
      //navigate(`/deeplink?url=/calls/callhistory.aspx?call_id=${tIds[0]}`);
      navigate(`/ticket/${tIds[0]}`);
    } else if (
      myOptions?.indexOf("3") === -1 &&
      myOptions?.indexOf("4") === -1
    ) {
      //If no "Log another" option is chosen
      //just close the popup by going Back
      goBack();
    }
  };

  const { data: existingTicket } = Api.useGetTicketQuery(
    { ticketId: ticketId ? parseInt(ticketId) : 0, populateFormData: true },
    { skip: !ticketId }
  );
  const { data: userProfile, isLoading: profileIsLoading } =
    Api.useGetUserProfileQuery(null);
  const ticketTitle = (
    <div className="custom-toolbar">
      <Button
        icon="menu"
        fillMode="flat"
        title="Toggle toolbar"
        onClick={handleClick}
      />
      <span className="title">
        {existingTicket
          ? `${userProfile?.Phrases.CallPhrase} ${existingTicket.ID}`
          : userProfile?.Phrases.CallPhrase ? `New ${userProfile?.Phrases.CallPhrase}` : ''}
      </span>
    </div>
  );

  var modalWindow = (
    <div className={props.isModal ? undefined : "modal-ticket-wrapper"}>
      <Window minimizeButton={() => null}
        onMove={moving}
        top={size.t}
        left={size.l}
        width={size.w}
        height={size.h}
        onResize={resizing}
        className="ticket-details"
        onClose={goBack}
        stage={props.isModal ? undefined : "FULLSCREEN"}
        title={ticketTitle}
        modal={props.isModal}
      >
        {profileIsLoading && <PartialSpinny />}
        {!profileIsLoading && (
          <>
            {/* location:{JSON.stringify(size)} */}

            <TicketDrawer
              expanded={expanded}
              ticketSaved={ticketSaved}
            ></TicketDrawer>
          </>
        )}
      </Window>
    </div>
  );
  const nonModalForm = (
    <div className="ticket-details">
      <TicketDrawer
        expanded={expanded}
        ticketSaved={ticketSaved}
      ></TicketDrawer>
    </div>
  );

  return props.isModal ? modalWindow : nonModalForm;
};

type windowDims = {
  w: number;
  h: number;
  t?: number;
  l?: number;
};
